import {
  DASHBOARD_TITLES,
  type DashboardQuery,
} from '../../../hooks/dashboard/dashboardConfig';
import type { DashboardTileId } from './dashboardLayout';

// The board's card titles; the legacy dashboard keeps DASHBOARD_TITLES.
export const BOARD_TITLES: Record<DashboardTileId, string> = {
  ...DASHBOARD_TITLES,
  active_patient_census: 'Active Patients',
  onboarding_checklist: 'Getting set up',
  onboarding_activity: 'Onboarding activity',
};

// A pie has seven series colours and a grey for Other, so it shows at most 8.
export const CHART_ITEM_LIMIT_MAX = 8;

// The page behind each card; its title links there.
export const BOARD_LINKS: Record<DashboardQuery, string> = {
  active_patient_census: '/patients',
  case_manager_queue: '/tasks',
  outstanding_oasis: '/oasis-manager',
  past_due_tasks: '/tasks',
  census_by_primary_insurer: '/patients',
  orders_pending_signature: '/orders',
  census_by_primary_diagnosis: '/patients',
};
